
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectCheckRuleTypeEnum } from '../models/work-project-check-rule-type-enum';
import { WorkProjectCheckStatusEnum } from '../models/work-project-check-status-enum';
import { WorkProjectCheckRuleApplicableBlockTypeEnum } from '../models/work-project-check-rule-applicable-block-type-enum';

export function getUpdateProjectCheckRuleDtoFormGroup() {
return new FormGroup({
    identifier: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    name: new FormControl<string | undefined>('', [Validators.maxLength(200)]),
    ruleType: new FormControl<WorkProjectCheckRuleTypeEnum | undefined>(undefined),
    enabled: new FormControl<boolean | undefined>(undefined),
    sortOrder: new FormControl<number | undefined>(undefined),
    activeFromWeeksBeforeInstallation: new FormControl<number | undefined>(undefined),
    activeFromDate: new FormControl<string | undefined>(undefined),
    config: new FormControl<any | undefined>(undefined),
    messageOk: new FormControl<string | undefined>(undefined),
    messageWarning: new FormControl<string | undefined>(undefined),
    messageProblem: new FormControl<string | undefined>(undefined),
    messageNone: new FormControl<string | undefined>(undefined),
    statusWhenInactive: new FormControl<WorkProjectCheckStatusEnum | undefined>(undefined),
    applicableBlockTypes: new FormControl<WorkProjectCheckRuleApplicableBlockTypeEnum | undefined>(undefined),
    applicableTaskStandardtaskIds: new FormControl<Array<number> | undefined>([]),
    visibleInMontageplan: new FormControl<boolean | undefined>(undefined),
    visibleForCustomer: new FormControl<boolean | undefined>(undefined),
    customerLabel: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    customerMessageOk: new FormControl<string | undefined>(undefined),
    customerMessageWarning: new FormControl<string | undefined>(undefined),
    customerMessageProblem: new FormControl<string | undefined>(undefined),
})
;
}
      